import Icon from 'veui/components/Icon'

Icon.register({
  leaf: {
    paths: [
      {
        d: 'M27.57 10.4c-.28-.67-1.04-1-1.71-.73-.13.05-2.69 1.05-5.36 2.82-.62-.92-1.31-1.8-2.07-2.6a32.4 32.4 0 00-4.82-4.18 43.18 43.18 0 00-6.08-3.67 1.33 1.33 0 00-1.8.69c-.06.13-1.27 3.06-2.16 6.97a34.59 34.59 0 00-.89 6.45 17.5 17.5 0 00.9 6.61c1.27 3.45 4.24 5.91 8.57 7.12a22.38 22.38 0 006.03.79h.04a20.93 20.93 0 004.3-1.17 14.54 14.54 0 003.35-1.82 8.37 8.37 0 002.68-3.18c2.53-5.48-.83-13.75-.98-14.1zM6.08 21.84c-1.99-5.4.46-13.52 1.6-16.72a42.8 42.8 0 014.37 2.76c3.86 2.77 6.44 5.7 7.46 8.48 1 2.72.92 5.56-.24 8.45-.3.74-.66 1.46-1.08 2.15-1.37-2.08-3.6-5.88-4.2-9.36a1.33 1.33 0 10-2.63.45c.62 3.66 2.73 7.46 4.22 9.8-3.02-.38-7.9-1.66-9.5-6.01zm20.05 1.54c-.84 1.83-2.94 2.98-4.55 3.62l-.46.18a15.28 15.28 0 001.71-5.96c.15-1.96-.13-3.94-.82-5.78l-.23-.6a28.7 28.7 0 013.79-2.13c.33 1.02.61 2.05.83 3.1.45 2.2.77 5.3-.27 7.57z'
      }
    ],
    width: '32',
    height: '32'
  }
})
